<template>
    <article
        v-if="author && Object.keys(author).length"
        class="author-box pa-7 mb-10 mt-2"
    >
        <header class="author-box__header d-flex justify-content-start align-items-center">
            <div class="author-box__avatar ml-2">
                <img
                    v-if="author.avatar && author.avatar.length"
                    :src="author.avatar[0].link"
                    :alt="author.name_full"
                >
                <img
                    v-else
                    src="@/assets/images/man.png"
                    :alt="author.name_full"
                >
            </div>
            <div
                v-if="author.name_full"
                class="typo-body-1"
            >
                {{ author.name_full }}
            </div>
        </header>
        <p
            v-if="author.biography"
            class="typo-body-2 author-box__description"
        >
            {{ author.biography }}
        </p>
    </article>
</template>

<script>

    export default {
        name: 'Author',
        
        props: {
            /**
             * author of post
             */
            author: Object,
        },
    };
</script>

<style lang="scss" src="./index.scss" />
